/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseFinancialListItemViewModelPaginatedResponse } from "../types/CourseFinancialListItemViewModelPaginatedResponse.ts";
import { courseFinancialListItemViewModelSchema } from "./courseFinancialListItemViewModelSchema.ts";

export const courseFinancialListItemViewModelPaginatedResponseSchema = z.object(
  {
    data: z
      .array(z.lazy(() => courseFinancialListItemViewModelSchema))
      .nullish(),
    currentPage: z.optional(z.number().int()),
    totalPages: z.optional(z.number().int()),
    totalCount: z.optional(z.number().int()),
  },
) as unknown as ToZod<CourseFinancialListItemViewModelPaginatedResponse>;
